import { useNavigate } from "react-router-dom"
import { FaFacebook, FaInstagram } from "react-icons/fa"
import petallogo from '../assets/images/petallogo.jpg'
import { useContext, useState } from "react"
import { Modal } from "react-bootstrap"
import { Context } from "../context/AppContext"

const MainBanner2 = () => {
  const navigate = useNavigate()
  const [modal, showModal] = useState(false)
  const { setRestaurantId } = useContext(Context)

  const handleOpenModal = () => {
    showModal(true)
  }

  const handleToOrder = (id) => {
    setRestaurantId(id)
    navigate("/online-order")
  }


  return (
    <div
      className="main-bnr-three overflow-hidden "
      style={{
        backgroundImage: `url(${petallogo})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "80vh",
        position: "relative"
      }}
    >
      <div className="top-banner-text text-center mt-5">
        <span className="petals-text text-white">
          PETALS OF A PEONY
        </span>
      </div>
      <div className="center-content d-flex flex-column justify-content-center align-items-center text-center" >
        <h2 className=" text-white" style={{ whiteSpace: 'nowrap', margin: '10px', fontSize: '40px' }}>
          A TASTE OF CHINA
        </h2>
        <div className="banner-btn d-flex justify-content-center align-items-center">
          <div
            onClick={handleOpenModal}
            className="btn  btn-md shadow-primary m-r30 btn-hover-1"
            style={{
              backgroundColor:'#9d2a00'
            }}
          >
            <span>Order Online</span>
          </div>
          <div
            onClick={() => navigate("/menu")}
            className="btn btn-secondary btn-md shadow-primary btn-hover-1"
          >
            <span>View Menu</span>
          </div>
        </div>
      </div>
      <div className="social-icons d-flex justify-content-center align-items-center">
        <a href="https://www.instagram.com/petalsofapeony/" target="_blank" rel="noopener noreferrer" className="mx-2">
          <FaInstagram size={55} color="white" />
        </a>
        <a href="https://www.facebook.com/PetalsofaPeony/" target="_blank" rel="noopener noreferrer" className="mx-2">
          <FaFacebook size={55} color="white" />
        </a>
      </div>



    <Modal show={modal} onHide={() => showModal(false)} centered size="lg">
  <Modal.Header
    closeButton
    className="border-0"
    style={{
      backgroundColor: "#fff9f7",
      borderBottom: "1px solid rgba(157,42,0,0.15)",
    }}
  >
    <Modal.Title className="fw-bold text-dark">
      Choose a Location
    </Modal.Title>
  </Modal.Header>

  <Modal.Body
    className="bg-white text-dark"
    style={{ borderRadius: "0 0 1rem 1rem" }}
  >
    <div className="container py-3">
      <div className="row gy-4 justify-content-center">
        {[{
          title: "Cordova Location",
          address: "1250 N Germantown Pkwy Cordova, TN 38016",
          phone: "(901)-707-8886",
          id: 7
        }, {
          title: "Overton Square Location",
          address: "2110 Madison Ave Memphis, TN 38104",
          phone: "(901)-207-6680",
          id: 11
        }, {
          title: "小富贵 Little Petals Chinese (Downtown)",
          address: "149 Madison Ave, Memphis, TN 38103",
          phone: "(901)-628-0086",
          id: 40
        }, {
          title: "小富贵 Little Petals Chinese 2 (Poplar)",
          address: "5167 Poplar Ave, Memphis, TN 38117",
          phone: "(901)-668-9388",
          id: 73,
          isNew: true
        }].map((loc, index) => (
          <div key={index} className="col-12 col-md-6 col-lg-5">
            <div
              className="position-relative border rounded-4 shadow-sm h-100 p-4 text-center"
              style={{
                borderColor: "rgba(157,42,0,0.15)",
                background: "#fff",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.boxShadow =
                  "0 3px 8px rgba(157,42,0,0.2)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.boxShadow =
                  "0 2px 6px rgba(0,0,0,0.05)")
              }
            >
              {/* NEW Badge */}
              {loc.isNew && (
                <span
                  className="position-absolute top-0 start-50 translate-middle badge rounded-pill fw-semibold"
                  style={{
                    backgroundColor: "#9d2a00",
                    color: "#fff",
                    fontSize: "0.75rem",
                    transform: "translate(-50%, -50%)",
                    padding: "6px 12px",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  NEW
                </span>
              )}

              <h5 className="fw-bold mb-3 text-dark">{loc.title}</h5>
              <p className="mb-1">{loc.address}</p>
              <a
                href={`tel:${loc.phone.replace(/[^0-9]/g, "")}`}
                className="d-block mb-3 text-decoration-none text-muted fw-semibold"
              >
                {loc.phone}
              </a>
              <button
                onClick={() => handleToOrder(loc.id)}
                className="btn fw-semibold w-100"
                style={{
                  backgroundColor: "#9d2a00",
                  color: "#fff",
                  borderRadius: 12,
                  transition: "background-color 0.2s ease",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#b83500")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "#9d2a00")
                }
              >
                Order Here
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  </Modal.Body>
</Modal>

    </div>
  )
}

export default MainBanner2
